import { AngleDown as AngleDownIcon } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import { WorkspaceAvatar } from '../../../WorkspaceAvatar'
import css from './styles.module.css'

interface Props {
  open: boolean
  avatar: string | null
  title?: string
  onClick: () => void
  onSetRef: (
    ref:
      | ((prevState: HTMLElement | null) => HTMLElement | null)
      | HTMLElement
      | null
  ) => void
}

export const DropdownButtonMobile: React.FC<Props> = ({
  open,
  avatar,
  title,
  onClick,
  onSetRef,
}) => (
  <button ref={onSetRef} className={css.button} onClick={onClick}>
    <div className={clsJoin(css.wrapper, open && css.open)}>
      <WorkspaceAvatar url={avatar} />
      <div className={css.icon}>
        <AngleDownIcon />
      </div>
    </div>

    <span className={css.title}>{title}</span>
  </button>
)
